import * as React from 'react'
import { useTranslation } from 'react-i18next'
import './plate.css'
import numberFilterOnKeyPress from 'Utils/numberFilterOnKeyPress'
import BottomSheet from 'Components/BottomSheet'
import FDMBottomSheetSelectInput from 'Components/Form/Input/FDMBottomSheetSelectInput'
import { useForm } from 'react-hook-form'
import PaletInputFreeZone from 'Components/Form/Input/PaletInputFreeZone'

export interface IPlateModel {
  type: 'UNDEFINED' | 'CAR' | 'MOTOR_CYCLE' | 'TEMPORARY' | 'FREEZONE'
  cityCode?: string
  char?: string
  carSerial: string
  motorCycleSerial: string
  carOtherNumber?: string
  motorCycleOtherNumber?: string
  englishNumber?: string
  persianNumber?: string
  selectedZone?: {
    value?: string
    label?: string
    logo?: string
  }
  serialPlate?: { value: string; label: string; id: number }
}

const Plate = ({ showVehicleType = true, onChange = () => {}, ...props }: any) => {
  const { control } = useForm({})

  const [t] = useTranslation()
  const [type, setType] = React.useState<
    'UNDEFINED' | 'CAR' | 'MOTOR_CYCLE' | 'TEMPORARY' | 'FREEZONE'
  >('CAR')

  const [cityCode, setCityCode] = React.useState<string>('')
  const [open, setOpen] = React.useState(false)
  const [char, setChar] = React.useState<string>('')
  const [carSerial, setCarSerial] = React.useState<string>('')
  const [motorCycleSerial, setMotorCycleSerial] = React.useState<string>('')
  const [carOtherNumber, setCarOtherNumber] = React.useState<string>('')
  const [motorCycleOtherNumber, setMotorCycleOtherNumber] = React.useState<string>('')
  const inputRefs = [
    React.useRef<HTMLInputElement>(null),
    React.useRef<HTMLInputElement>(null),
    React.useRef<HTMLInputElement>(null),
    React.useRef<HTMLInputElement>(null),
  ]

  React.useEffect(() => {
    if (props.value) {
      setType(props.value.type)
      setCityCode(props.value.cityCode)
      setChar(props.value.char)
      setCarSerial(props.value.carSerial)
      setMotorCycleSerial(props.value.motorCycleSerial)
      setCarOtherNumber(props.value.carOtherNumber)
      setMotorCycleOtherNumber(props.value.motorCycleOtherNumber)
    }
  }, [props.value])

  const setValues = (
    valueType:
      | 'TYPE'
      | 'FREEZONE_TYPE'
      | 'CITY_CODE'
      | 'CHAR'
      | 'CAR_SERIAL'
      | 'MOTOR_CYCLE_SERIAL'
      | 'CAR_OTHER_NUMBER'
      | 'MOTOR_CYCLE_OTHER_NUMBER',
    value: any,
  ) => {
    const currentType = valueType === 'TYPE' ? value : type

    let plate: IPlateModel = {
      type: currentType,
      cityCode:
        currentType === 'TEMPORARY'
          ? '-'
          : valueType === 'CITY_CODE'
            ? value
            : cityCode === '-'
              ? ''
              : cityCode,

      char:
        currentType === 'TEMPORARY' ? 'گ' : valueType === 'CHAR' ? value : char === 'گ' ? '' : char,

      carSerial: valueType === 'CAR_SERIAL' ? value : carSerial,
      motorCycleSerial: valueType === 'MOTOR_CYCLE_SERIAL' ? value : motorCycleSerial,
      carOtherNumber: valueType === 'CAR_OTHER_NUMBER' ? value : carOtherNumber,
      motorCycleOtherNumber:
        valueType === 'MOTOR_CYCLE_OTHER_NUMBER' ? value : motorCycleOtherNumber,
    }

    onChange(plate)
  }

  const handleClickOpen = (e: any) => {
    e.preventDefault()
    setOpen(true)
  }

  const handleClose = (data: any) => {
    if (data) {
      setChar(data.value)
      setValues('CHAR', data.value)
    }
    setOpen(false)
  }

  var chars = [
    { value: 'الف', label: 'الف' },
    { value: 'ب', label: 'ب' },
    { value: 'پ', label: 'پ' },
    { value: 'ت', label: 'ت' },
    { value: 'ث', label: 'ث' },
    { value: 'ج', label: 'ج' },
    { value: 'د', label: 'د' },
    { value: 'ز', label: 'ز' },
    { value: 'ژ', label: 'ژ' },
    { value: 'س', label: 'س' },
    { value: 'ش', label: 'ش' },
    { value: 'ص', label: 'ص' },
    { value: 'ط', label: 'ط' },
    { value: 'ع', label: 'ع' },
    { value: 'ف', label: 'ف' },
    { value: 'ق', label: 'ق' },
    { value: 'ک', label: 'ک' },
    { value: 'گ', label: 'گ' },
    { value: 'ل', label: 'ل' },
    { value: 'م', label: 'م' },
    { value: 'ن', label: 'ن' },
    { value: 'و', label: 'و' },
    { value: 'ه', label: 'ه' },
    { value: 'ی', label: 'ی' },
    { value: 'D', label: 'D' },
    { value: 'S', label: 'S' },
  ]

  return (
    <React.Fragment>
      {showVehicleType && (
        <FDMBottomSheetSelectInput
          id="vehicleTypeId"
          name="vehicleTypeId"
          control={control}
          label={t('VEHICLE_TYPE')}
          rules={{ required: true }}
          withSearch
          options={[
            { value: 'CAR', label: t('CAR') },
            { value: 'MOTOR_CYCLE', label: t('MOTOR_CYCLE') },
            { value: 'TEMPORARY', label: t('PLATE_TEMPORARY') },
            { value: 'FREEZONE', label: t('FREE_ZONE') },
            { value: 'UNDEFINED', label: t('UNKNOW') },
          ]}
          disabled={props.typeDisabled}
          value={type}
          onChange={(value: any) => {
            setValues('TYPE', value?.value)
            setType(value?.value)
          }}
        />
      )}
      {type === 'UNDEFINED' ? (
        <div></div>
      ) : type === 'FREEZONE' ? (
        <PaletInputFreeZone
          value={props.value}
          onChange={val => {
            onChange(val)
          }}
          mode={props.mode}
        />
      ) : type === 'MOTOR_CYCLE' ? (
        <div className="group">
          <div className="iran-vehicle-number-plate motorcycle mx-auto mb-3 group-[.validation-error]:bg-error">
            <div className="number-plate flex-col">
              <div className="flex">
                <div className="px-2 pt-2 grow">
                  <input
                    inputMode="numeric"
                    ref={inputRefs[0]}
                    value={motorCycleSerial}
                    onChange={(e: any) => {
                      setMotorCycleSerial(e.target.value)
                      setValues('MOTOR_CYCLE_SERIAL', e.target.value)
                      if (e.target.value.length == 3) inputRefs[1].current?.focus()
                    }}
                    onKeyPress={numberFilterOnKeyPress}
                    disabled={props.disabled}
                    type="text"
                    className="form-text"
                    minLength={3}
                    maxLength={3}
                    tabIndex={1}
                    autoComplete={'off'}
                    dir="ltr"
                  />
                </div>
                <div className="plate-flag"></div>
              </div>
              <div className="px-2 pb-2">
                <input
                  inputMode="numeric"
                  ref={inputRefs[1]}
                  value={motorCycleOtherNumber}
                  onChange={(e: any) => {
                    setMotorCycleOtherNumber(e.target.value)
                    setValues('MOTOR_CYCLE_OTHER_NUMBER', e.target.value)
                  }}
                  onKeyPress={numberFilterOnKeyPress}
                  disabled={props.disabled}
                  type="text"
                  className="form-text"
                  minLength={5}
                  maxLength={5}
                  tabIndex={2}
                  autoComplete={'off'}
                  dir="ltr"
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="group">
          <div className="iran-vehicle-number-plate group-[.validation-error]:bg-error">
            <div className="number-plate plate-iran">
              <input
                inputMode="numeric"
                ref={inputRefs[3]}
                value={cityCode}
                onChange={(e: any) => {
                  setCityCode(e.target.value)
                  setValues('CITY_CODE', e.target.value)
                }}
                onKeyPress={numberFilterOnKeyPress}
                type="text"
                className="form-text"
                disabled={type == 'TEMPORARY' || props.disabled}
                style={{
                  backgroundColor: type == 'TEMPORARY' ? 'lightgray' : '',
                }}
                minLength={2}
                maxLength={2}
                tabIndex={4}
                autoComplete={'off'}
                dir="ltr"
              />
            </div>
            <div className="number-plate">
              <input
                inputMode="numeric"
                ref={inputRefs[2]}
                value={carSerial}
                onChange={(e: any) => {
                  setCarSerial(e.target.value)
                  setValues('CAR_SERIAL', e.target.value)
                  if (e.target.value.length == 3) inputRefs[3].current?.focus()
                }}
                onKeyPress={numberFilterOnKeyPress}
                disabled={props.disabled}
                type="text"
                className="form-text"
                minLength={3}
                maxLength={3}
                tabIndex={3}
                autoComplete={'off'}
                dir="ltr"
              />
              <input
                ref={inputRefs[1]}
                value={chars.find(x => x.value == char)?.label ?? ''}
                onFocus={handleClickOpen}
                type="text"
                className="form-text"
                maxLength={2}
                disabled={type == 'TEMPORARY' || props.disabled}
                style={{
                  backgroundColor: type == 'TEMPORARY' ? 'lightgray' : '',
                }}
                tabIndex={2}
              />
              <BottomSheet title={'سری حرفی'} visible={open} onCancel={() => handleClose(null)}>
                <div
                  style={{
                    width: 50,
                    height: 6,
                    backgroundColor: '#ccc',
                    borderRadius: 3,
                    position: 'absolute',
                    top: 8,
                    left: '50%',
                    transform: 'translateX(-50%)',
                  }}
                />
                <div className="overflow-auto px-6 pb-6">
                  <div className="text-black text-sm mb-4">{`سری حرفی را مشخص کنید.`}</div>
                  {chars
                    .filter((option: any) =>
                      type == 'TEMPORARY' ? option.value == 'گ' : option.value != 'گ',
                    )
                    .map((option: any, index: number) => (
                      <label
                        className="flex items-center gap-2 py-2"
                        key={index}
                        onClick={() => {
                          handleClose(option)
                          inputRefs[2].current?.focus()
                        }}
                      >
                        <div className="grow flex items-center gap-2 font-semibold text-sm">
                          {option.label}
                        </div>
                        <input
                          type="radio"
                          name="status"
                          className="radio-primary"
                          checked={option.value == char}
                        />
                      </label>
                    ))}
                </div>
              </BottomSheet>

              <input
                inputMode="numeric"
                ref={inputRefs[0]}
                value={carOtherNumber}
                onChange={(e: any) => {
                  setCarOtherNumber(e.target.value)
                  setValues('CAR_OTHER_NUMBER', e.target.value)
                  if (e.target.value.length == 2) inputRefs[1].current?.focus()
                }}
                onKeyPress={numberFilterOnKeyPress}
                disabled={props.disabled}
                type="text"
                className="form-text"
                minLength={2}
                maxLength={2}
                tabIndex={1}
                autoComplete={'off'}
                dir="ltr"
              />
            </div>
            <div className="plate-flag"></div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

export default Plate
